/*
 Created by qing 2020/2/10 11:01 上午
 */
import {
  FORM_ITEM__SINGLE_LINE,
  FORM_ITEM__MULTILINE,
  FORM_ITEM__RTF,
  FORM_ITEM__SINGLE_CHOOSE,
  FORM_ITEM__DROPDOWN,
  FORM_ITEM__SERIAL_NUMBER,
  FORM_ITEM__GRADE,
  FORM_ITEM__SLIDING_BLOCK,
  FORM_ITEM__EXTERNAL_DATA_SOURCE,
  FORM_ITEM__NUMBER,
  FORM_ITEM__CURRENCY,
  FORM_ITEM__REALTIME_DATA,
  FORM_ITEM__YES_NO,
  FORM_ITEM__DATE,
  FORM_ITEM__CHECKBOX,
  FORM_ITEM__IMAGE,
  FORM_ITEM__ATTACHMENT,
  FORM_ITEM__IMAGE_CHOOSE,
  FORM_ITEM__ADDRESS,
  FORM_ITEM__MEMBER,
  FORM_ITEM__DEPARTMENT,
  FORM_ITEM__PHONE,
  FORM_ITEM__LOCATION,
  FORM_ITEM__DESCRIPTION,
  DATE_TYPE__DAY,
  FORM_ITEM__DATE_RANGE,
  FORM_ITEM__SUMMARY,
  FORM_ITEM__OUT_REQUEST,
  MESSAGE_TYPE_UPDATE_FORM,
  MESSAGE_TYPE_DATA,
  MESSAGE_TYPE_APPEND,
  MESSAGE_TYPE_SIGNATURE,
  MESSAGE_TYPE_UPLOAD_IMAGE,
  FORM_ITEM__RELATE_RECORD,
  FORM_ITEM__CURRENT_VIEW_USER,
  FORM_ITEM__FORM_RUN_STATUS,
  FORM_ITEM__FLOW_DETAIL_INFO,
  FORM_ITEM__TABLE,
  FORM_ITEM__CASCADE, DATA_TYPE__NUMBER, DATA_TYPE__STRING
} from "../../src/RyForm/types"
import AreaData from "../../src/RyForm/instances/AreaData.js"
import {
  FILTER_METHOD_TYPE__ALL,
  FILTER_METHOD_TYPE__EMPTY,
  FILTER_METHOD_TYPE__EQ,
  FILTER_METHOD_TYPE__GT,
  FILTER_METHOD_TYPE__GTE,
  FILTER_METHOD_TYPE__IN,
  FILTER_METHOD_TYPE__LIKE,
  FILTER_METHOD_TYPE__LT,
  FILTER_METHOD_TYPE__LTE,
  FILTER_METHOD_TYPE__NE,
  FILTER_METHOD_TYPE__NIN,
  FILTER_METHOD_TYPE__NOT_EMPTY,
  FILTER_METHOD_TYPE__RANGE,
  FILTER_METHOD_TYPE__UNLIKE
} from "../../src/component/FilterWidget/types";
import CryptoJS from "crypto-js";
import {ENCODE_TYPE_ZEUS, ENV_TYPE_SMALLPROGRAM} from "../../src/store/types";
import { phones } from '../../src/Regex'
import fa from "element-ui/src/locale/lang/fa";
import contextVue from "../../src/main";
import store from "../../src/store";

export function clone(obj) {
  return JSON.parse(JSON.stringify(obj))
}

export function arrayRemove(array, val) {
  let index = -1
  for (let i = 0; i < array.length; i++) {
    if (array[i] === val) {
      index = i
    }
  }
  if (index > -1) {
    array.splice(index, 1)
  }
}

// 判断数组中值是否相同 arrayEquals([1,2,3], [2,1,3]); // true    arrayEquals([1,2], [1,1]); // false
export function arrayEquals(value1 = [], value2 = []) {
  let hash = clone(value2);
  if (value1.length === value2.length) {
    for (let i = 0; i < value1.length; i++) {
      const index = hash.indexOf(value1[i]);
      if (index > -1) {
        hash.splice(index, 1);
      } else {
        return false;
      }
    }
    return true;
  }
  return false;
}

export function arrayRandomElement(array) {
  return array[Math.floor(Math.random() * array.length)]
}
// 数组交集
export function getArrRepeat(arr1, arr2) {
  return arr1.filter(item => {
    return arr2.includes(item)
  })
}

export function arrayUnique(arr) {
  return Array.from(new Set(arr))
}

export function objectArrayUnique(arr, key) {
  if (!arr) return arr
  if (key === undefined) return [...new Set(arr)]
  const map = {
    'string': e => e[key],
    'function': e => key(e),
  }
  const fn = map[typeof key]
  const obj = arr.reduce((o, e) => (o[fn(e)] = e, o), {})
  return Object.values(obj)
}
/**
 * 方法名：
 * 功能介绍：返回一个对象里面包含后一个数组比第一个数组增加、减少的数据（适用于去重过后的数组）
 * 参数：
 * beforeArr：前一个数组
 * afterArr：后一个数组
 */
export function arrCompare(beforeArr, afterArr) {
  let resObj = {
      add: [],
      del: []
    },
    cenObj = {};
  //把beforeArr数组去重放入cenObj
  for (let i = 0; i < beforeArr.length; i++) {
    cenObj[beforeArr[i]] = beforeArr[i];
  }
  //遍历afterArr，查看其元素是否在cenObj中
  for (let j = 0; j < afterArr.length; j++) {
    if (!cenObj[afterArr[j]]) {
      resObj.add.push(afterArr[j]);
    } else {
      delete cenObj[afterArr[j]]
    }
  }
  Object.values(cenObj).forEach(k => {
    resObj.del.push(k);
  })
  return resObj;
}

// 数组排序  升序
export function arraySort(property,desc) {
  return function (a, b) {
    var value1 = a[property];
    var value2 = b[property];
    if(desc){
      // 升序排列
      return value1 - value2;
    }else{
      // 降序排列
      return value2 - value1;
    }
  }
}
export function formatDate(d) {
  if (!isNull(d) && !isUndefined(d)) {
    let date = new Date(d)
    return fmt => { //author: meizz
      let o = {
        'M+': date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'H+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        'S': date.getMilliseconds() //毫秒
      }
      if (/(y+)/.test(fmt)) {
        fmt =
          fmt.replace(RegExp.$1, (date.getFullYear() + ``).substr(4 - RegExp.$1.length))
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          fmt =
            fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00` + o[k]).substr(
              (`` + o[k]).length)))
        }
      }
      return fmt
    }
  } else {
    return (d) => {
      return ``
    }
  }
}

export function getweek(time) {
  /*显示星期*/
  /*time为date格式*/
  let str;
  const d = time.getDay();
  switch (d) {
    case 0:
      str = '星期天';
      break;
    case 1:
      str = '星期一';
      break;
    case 2:
      str = '星期二';
      break;
    case 3:
      str = '星期三';
      break;
    case 4:
      str = '星期四';
      break;
    case 5:
      str = '星期五';
      break;
    case 6:
      str = '星期六';
      break;
  }
  return str;
}

export function getWeek(time) {
  /*显示星期*/
  /*time为date格式*/
  let str;
  const d = time.getDay();
  switch (d) {
    case 0:
      str = '周天';
      break;
    case 1:
      str = '周一';
      break;
    case 2:
      str = '周二';
      break;
    case 3:
      str = '周三';
      break;
    case 4:
      str = '周四';
      break;
    case 5:
      str = '周五';
      break;
    case 6:
      str = '周六';
      break;
  }
  return str;
}

export function isWorkTime(date) {
  const d = date.getDay();
  if (d === 0 || d === 6) {
    return false
  } else {
    return true
  }
}
// 精确格式化时间（刚刚、N分钟前、今天几点几分、昨天几点几分等）传13位毫秒值
export function accurateFormatDate(timestamp) {
  timestamp = timestamp / 1000

  function zeroize(num) {
    return (String(num).length === 1 ? '0' : '') + num;
  }

  let curTimestamp = parseInt(new Date().getTime() / 1000); //当前时间戳
  let timestampDiff = curTimestamp - timestamp; // 参数时间戳与当前时间戳相差秒数

  let curDate = new Date(curTimestamp * 1000); // 当前时间日期对象
  let tmDate = new Date(timestamp * 1000);  // 参数时间戳转换成的日期对象

  let Y = tmDate.getFullYear(), m = tmDate.getMonth() + 1, d = tmDate.getDate();
  let H = tmDate.getHours(), i = tmDate.getMinutes(), s = tmDate.getSeconds();

  if (timestampDiff < 0) {
    if (curDate.getFullYear() === Y) {
      return zeroize(m) + '月' + zeroize(d) + '日 ' + zeroize(H) + ':' + zeroize(i);
    } else {
      return Y + '年' + zeroize(m) + '月' + zeroize(d) + '日 ' + zeroize(H) + ':' + zeroize(i);
    }
  } else if (timestampDiff < 60) { // 一分钟以内
    return "刚刚";
  } else if (timestampDiff < 3600) { // 一小时前之内
    return Math.floor(timestampDiff / 60) + "分钟前";
  } else if (curDate.getFullYear() === Y && curDate.getMonth() + 1 === m && curDate.getDate() === d) {
    return '今天' + zeroize(H) + ':' + zeroize(i);
  } else {
    let newDate = new Date((curTimestamp - 86400) * 1000); // 参数中的时间戳加一天转换成的日期对象
    if (newDate.getFullYear() === Y && newDate.getMonth() + 1 === m && newDate.getDate() === d) {
      return '昨天' + zeroize(H) + ':' + zeroize(i);
    } else if (curDate.getFullYear() === Y) {
      return zeroize(m) + '月' + zeroize(d) + '日 ' + zeroize(H) + ':' + zeroize(i);
    } else {
      return Y + '年' + zeroize(m) + '月' + zeroize(d) + '日 ' + zeroize(H) + ':' + zeroize(i);
    }
  }

}

/**
 * 获取任意一天当月第一天时间戳 0:0:0
 * @param time 时间戳 不传默认当月
 */
export function getCurrentMonthFirstDay(time) {
  let now = new Date()
  if (time) {
    now = new Date(time)
  }
  now.setDate(1)
  now.setHours(0, 0, 0, 0)

  return now.getTime()
}

/**
 * 获取任意一天当月最后一天时间戳 23:59:59
 * @param time 时间戳 不传默认当月
 */
export function getCurrentMonthLastDay(time) {
  let now = new Date()
  if (time) {
    now = new Date(time)
  }
  // 下月
  if (now.getMonth() === 11) {
    now.setMonth(0)
  } else {
    now.setMonth(now.getMonth() + 1)
  }
  now.setDate(1)
  now.setHours(0, 0, 0, 0)

  return now.getTime() - 1000
}

/**
 * 获取任意一天的开始时间 0：0：0
 * @param time 时间戳
 */
export function startTime(time) {
  let nowTimeDate = new Date(time)
  return nowTimeDate.setHours(0, 0, 0, 0)
}

/**
 * 获取任意一天的结束时间 23:59:59
 * @param time 时间戳
 */
export function endTime(time) {
  let nowTimeDate = new Date(time)
  return nowTimeDate.setHours(23, 59, 59, 999)
}

// 本月第一天0点时间戳
export function getCurrentMonthFirst() {
  let date = new Date();
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date.getTime();
}

// 本月最后天24点时间戳
export function getCurrentMonthLast() {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  month++;
  if (month > 12) {
    year++;
    month = 1;
  }
  let newDate = new Date(year, month - 1, 1);
  return (new Date(newDate.getTime() - 1)).getTime()
}

/***
 * 获得当前时间
 */
export function getCurrentDate() {
  return new Date();
}

/**
 * 返回上一个月的第一天Date类型
 * @param year 年
 * @param month 月
 **/
export function getPriorMonthFirstDay(year, month) {
  //年份为0代表,是本年的第一月,所以不能减
  if (month == 0) {
    month = 11; //月份为上年的最后月份
    year--; //年份减1
    return new Date(year, month, 1);
  }
  //否则,只减去月份
  month--;
  return new Date(year, month, 1)
}

/**
 * 获得该月的天数
 * @param year年份
 * @param month月份
 * */
export function getMonthDays(year, month) {
  //本月第一天 1-31
  let relativeDate = new Date(year, month, 1);
  //获得当前月份0-11
  let relativeMonth = relativeDate.getMonth();
  //获得当前年份4位年
  let relativeYear = relativeDate.getFullYear();

  //当为12月的时候年份需要加1
  //月份需要更新为0 也就是下一年的第一个月
  if (relativeMonth == 11) {
    relativeYear++;
    relativeMonth = 0;
  } else {
    //否则只是月份增加,以便求的下一月的第一天
    relativeMonth++;
  }
  //一天的毫秒数
  let millisecond = 1000 * 60 * 60 * 24;
  //下月的第一天
  let nextMonthDayOne = new Date(relativeYear, relativeMonth, 1);
  //返回得到上月的最后一天,也就是本月总天数
  return new Date(nextMonthDayOne.getTime() - millisecond).getDate();
}

/**
 * 获得上一月的起止日期时间戳
 * ***/
export function getPreviousMonth() {
  //起止日期数组
  let startStop = []
  //获取当前时间
  let currentDate = getCurrentDate()
  //获得当前月份0-11
  let currentMonth = currentDate.getMonth()
  //获得当前年份4位年
  let currentYear = currentDate.getFullYear()
  //获得上一个月的第一天
  let priorMonthFirstDay = getPriorMonthFirstDay(currentYear, currentMonth)
  //获得上一月的最后一天
  let priorMonthLastDay = new Date(priorMonthFirstDay.getFullYear(), priorMonthFirstDay.getMonth(), getMonthDays(priorMonthFirstDay.getFullYear(), priorMonthFirstDay.getMonth()))
  //添加至数组
  startStop.push(priorMonthFirstDay.getTime())
  startStop.push(endTime(priorMonthLastDay.getTime()))
  //返回
  return startStop;
};

/***
 *  @return {*} WeekFirstDay 返回本周第一天的时间 0点
 */
export function showWeekFirstDay() {
  let nowDate = new Date();
  let weekFirstDay = new Date(nowDate - (nowDate.getDay() - 1) * 86400000);
  return startTime(weekFirstDay.getTime())
}

/***
 *  @return {*} WeekLastDay 返回本周最后一天的时间 24点
 */
export function showWeekLastDay() {
  let nowDate = new Date();
  let weekFirstDay = new Date(nowDate - (nowDate.getDay() - 1) * 86400000);
  let weekLastDay = new Date((weekFirstDay / 1000 + 6 * 86400) * 1000);
  return endTime(weekLastDay.getTime())
}

/**
 * 获得上一周的第一天 0点
 * **/
export function getPreviousWeekFirstDay() {
  //获取当前时间
  let currentDate = getCurrentDate();
  //返回date是一周中的某一天
  let week = currentDate.getDay()
  //返回date是一个月中的某一天
  let month = currentDate.getDate()
  //一天的毫秒数
  let millisecond = 1000 * 60 * 60 * 24
  //减去的天数
  let minusDay = week != 0 ? week - 1 : 6
  //获得当前周的第一天
  let currentWeekDayOne = currentDate.getTime() - (millisecond * minusDay)
  //上周最后一天即本周开始的前一天
  let priorWeekLastDay = currentWeekDayOne - millisecond
  //上周的第一天
  let priorWeekFirstDay = priorWeekLastDay - (millisecond * 6)

  return startTime(priorWeekFirstDay)
}

/**
 * 获得上一周的最后一天 24点
 * **/
export function getPreviousWeekLastDay() {
  //获取当前时间
  let currentDate = getCurrentDate()
  //返回date是一周中的某一天
  let week = currentDate.getDay()
  //返回date是一个月中的某一天
  let month = currentDate.getDate()
  //一天的毫秒数
  let millisecond = 1000 * 60 * 60 * 24
  //减去的天数
  let minusDay = week != 0 ? week - 1 : 6
  //获得当前周的第一天
  let currentWeekDayOne = currentDate.getTime() - (millisecond * minusDay)
  //上周最后一天即本周开始的前一天
  let priorWeekLastDay = currentWeekDayOne - millisecond

  return endTime(priorWeekLastDay)
}

/**
 * 得到本季度开始的月份
 * @param month 需要计算的月份
 ***/
export function getQuarterSeasonStartMonth(month) {
  let quarterMonthStart = 0;
  let spring = 0; //春
  let summer = 3; //夏
  let fall = 6;   //秋
  let winter = 9; //冬
  //月份从0-11
  if (month < 3) {
    return spring;
  }

  if (month < 6) {
    return summer;
  }

  if (month < 9) {
    return fall;
  }

  return winter;
}

/**
 * 获得本季度的起止日期
 */
export function getCurrentSeason() {
  //起止日期数组
  let startStop = new Array();
  //获取当前时间
  let currentDate = getCurrentDate();
  //获得当前月份0-11
  let currentMonth = currentDate.getMonth();
  //获得当前年份4位年
  let currentYear = currentDate.getFullYear();
  //获得本季度开始月份
  let quarterSeasonStartMonth = this.getQuarterSeasonStartMonth(currentMonth);
  //获得本季度结束月份
  let quarterSeasonEndMonth = quarterSeasonStartMonth + 2;

  //获得本季度开始的日期
  let quarterSeasonStartDate = new Date(currentYear, quarterSeasonStartMonth, 1);
  //获得本季度结束的日期
  let quarterSeasonEndDate = new Date(currentYear, quarterSeasonEndMonth, getMonthDays(currentYear, quarterSeasonEndMonth));
  //加入数组返回
  startStop.push(startTime(quarterSeasonStartDate.getTime()))
  startStop.push(endTime(quarterSeasonEndDate.getTime()))
  //返回
  return startStop;
};

/***
 * 得到本年的起止日期
 *
 */
export function getCurrentYear() {
  //起止日期数组
  let startStop = new Array();
  //获取当前时间
  let currentDate = getCurrentDate();
  //获得当前年份4位年
  let currentYear = currentDate.getFullYear();

  //本年第一天
  let currentYearFirstDate = new Date(currentYear, 0, 1);
  //本年最后一天
  let currentYearLastDate = new Date(currentYear, 11, 31);
  //添加至数组
  startStop.push(startTime(currentYearFirstDate.getTime()))
  startStop.push(endTime(currentYearLastDate.getTime()))
  //返回
  return startStop;
}
// 获取当前时间区间，返回 早上、上午、中午、下午、晚上
export function fetchCurrentDateRange() {
  const tmDate = new Date() //当前时间
  const H = tmDate.getHours()
  if (6 <= H && H < 9) {
    return '早上'
  } else if (9 <= H && H < 12) {
    return '上午'
  } else if (12 <= H && H < 14) {
    return '中午'
  } else if (14 <= H && H < 18) {
    return '下午'
  } else {
    return '晚上'
  }
}
// 数组排序  升序
export function arrayCompare(property,desc) {
  return function (a, b) {
    var value1 = a[property];
    var value2 = b[property];
    if(desc){
      // 升序排列
      return value1 - value2;
    }else{
      // 降序排列
      return value2 - value1;
    }
  }
}
export function base64ToFile (dataUrl, filename) {//将base64转换为文件
  const arr = dataUrl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, {type: mime})
}

//获取base64图片大小，返回kB数字
export function showSize(base64url) {
  //把头部去掉
  let str = base64url.replace('data:image/png;base64,', '');
  // 找到等号，把等号也去掉
  let equalIndex = str.indexOf('=');
  if(str.indexOf('=')>0) {
    str=str.substring(0, equalIndex);
  }
  // 原来的字符流大小，单位为字节
  let strLength=str.length;
  // 计算后得到的文件流大小，单位为字节
  let fileLength=parseInt(strLength-(strLength/8)*2);
  // 由字节转换为kb
  let size = "";
  size = (fileLength / 1024).toFixed(2);
  let sizeStr = size + ""; //转成字符串
  let index = sizeStr.indexOf("."); //获取小数点处的索引
  let dou = sizeStr.substr(index + 1, 2) //获取小数点后两位的值
  if (dou == "00") { //判断后两位是否为00，如果是则删除00
    return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
  }
  return size;
}

// 根据fieldType转化field value
export function fetchFieldValue({fieldType, value, dateType, dataType}) {
  console.log({fieldType, value, dateType, dataType})
  if (dataType === DATA_TYPE__STRING || dataType === DATA_TYPE__NUMBER) {
    return value
  } else {
    switch (fieldType) {
      case FORM_ITEM__DATE:
        let format = 'yyyy-MM-dd HH:mm:ss'
        if (dateType === DATE_TYPE__DAY) {
          format = 'yyyy-MM-dd'
        }
        return formatDate(value)(format)
      case FORM_ITEM__CHECKBOX:
        return value.map(opt => opt.optionName).join('、')
      case FORM_ITEM__DATE_RANGE:
        let dateFormat = 'yyyy-MM-dd HH:mm:ss'
        if (dateType === DATE_TYPE__DAY) {
          dateFormat = 'yyyy-MM-dd'
        }
        return formatDate(value[0])(dateFormat) + '~' + formatDate(value[1])(dateFormat)
      case FORM_ITEM__ADDRESS:
        return [value.province, value.city, value.county, value.detailAddress].join('')
      case FORM_ITEM__SUMMARY:
        return value.summaryValue
      case FORM_ITEM__MEMBER:
      case FORM_ITEM__DEPARTMENT:

        const depList = store.getters.depListMap,
          roleList = store.getters.roleListMap,
          userList = store.getters.userListMap,
          leaveMemberListMap = store.getters.leaveMemberListMap,
          extList = store.getters.extMap,
          leaveExternalMap = store.getters.leaveExternalMap,
          labelList = store.getters.extLabelMap

        value = value || this.value
        if (!value.depart) value.depart = []
        if (!value.role) value.role = []
        if (!value.member) value.member = []
        if (!value.external) value.external = []
        if (!value.externalTag) value.externalTag = []
        return [
          ...value.depart.map(depId => depList[depId] ? depList[depId].depName : ''),
          ...value.role.map(roleId => roleList[roleId] ? roleList[roleId].roleName : ''),
          ...value.member.map(userId => {
            if (userList[userId]) {
              return userList[userId].nickname
            } else if (leaveMemberListMap[userId]) {
              return leaveMemberListMap[userId].nickname
            } else {
              return  ''
            }
          }),
          ...value.external.map(userId => {
            if (extList[userId]) {
              return extList[userId].orgUserName
            } else if (leaveExternalMap[userId]) {
              return leaveExternalMap[userId].orgUserName
            } else {
              return  ''
            }
          }),
          ...value.externalTag.map(labelId => labelList[labelId] ? labelList[labelId].labelName : '')
        ].filter(item => !!item).join('、')
      case FORM_ITEM__LOCATION:
        return [value.province, value.city, value.county, value.detailAddress].join('')
      default:
        return ''
    }
  }

}

// 根据fieldType获取field过滤类型
export function fetchFieldFilterOpts(fieldType) {
  switch (fieldType) {
    case FORM_ITEM__SINGLE_LINE:
    case FORM_ITEM__MULTILINE:
    case FORM_ITEM__RTF:
    case FORM_ITEM__SINGLE_CHOOSE:
    case FORM_ITEM__DROPDOWN:
    case FORM_ITEM__SERIAL_NUMBER:
    case FORM_ITEM__EXTERNAL_DATA_SOURCE:
    case FORM_ITEM__OUT_REQUEST:
    case FORM_ITEM__PHONE:
      return [
        {
          name: '等于',
          method: 'eq'
        },
        {
          name: '不等于',
          method: 'ne'
        },
        {
          name: '等于任意一个',
          method: 'in'
        },
        {
          name: '不等于任意一个',
          method: 'nin'
        },
        {
          name: '包含',
          method: 'like'
        },
        {
          name: '不包含',
          method: 'unlike'
        },
        {
          name: '为空',
          method: 'empty'
        },
        {
          name: '不为空',
          method: 'not_empty'
        },
      ]
    case FORM_ITEM__CASCADE:
      return [
        {
          name: '等于任意一个',
          method: 'in'
        },
        {
          name: '不等于任意一个',
          method: 'nin'
        },
        {
          name: '包含',
          method: 'like'
        },
        {
          name: '不包含',
          method: 'unlike'
        },
        {
          name: '为空',
          method: 'empty'
        },
        {
          name: '不为空',
          method: 'not_empty'
        },
      ]
    case FORM_ITEM__SUMMARY:
    case FORM_ITEM__NUMBER:
    case FORM_ITEM__CURRENCY:
    case FORM_ITEM__REALTIME_DATA:
      return [
        {
          name: '等于',
          method: 'eq'
        },
        {
          name: '不等于',
          method: 'ne'
        },
        {
          name: '大于',
          method: 'gt'
        },
        {
          name: '大于等于',
          method: 'gte'
        },
        {
          name: '小于',
          method: 'lt'
        },
        {
          name: '小于等于',
          method: 'lte'
        },
        {
          name: '选择范围',
          method: 'range'
        },
        {
          name: '为空',
          method: 'empty'
        },
        {
          name: '不为空',
          method: 'not_empty'
        },
      ]
    case FORM_ITEM__YES_NO:
      return [
        {
          name: '等于',
          method: 'eq'
        },
        {
          name: '不等于',
          method: 'ne'
        }
      ]
    case FORM_ITEM__DATE:
      return [
        {
          name: '等于',
          method: 'eq'
        },
        {
          name: '不等于',
          method: 'ne'
        },
        {
          name: '大于等于',
          method: 'gte'
        },
        {
          name: '小于等于',
          method: 'lte'
        },
        {
          name: '选择范围',
          method: 'range'
        },
        {
          name: '为空',
          method: 'empty'
        },
        {
          name: '不为空',
          method: 'not_empty'
        },
      ]
    case FORM_ITEM__CHECKBOX:
    case FORM_ITEM__IMAGE_CHOOSE:
      return [
        {
          name: '包含任意一个',
          method: 'in'
        },
        {
          name: '同时包含',
          method: 'all'
        },
        {
          name: '等于',
          method: 'eq'
        },
        {
          name: '不等于',
          method: 'ne'
        },
        {
          name: '为空',
          method: 'empty'
        },
        {
          name: '不为空',
          method: 'not_empty'
        },
      ]
    case FORM_ITEM__LOCATION:
    case FORM_ITEM__IMAGE:
    case FORM_ITEM__ATTACHMENT:
      return [
        {
          name: '为空',
          method: 'empty'
        },
        {
          name: '不为空',
          method: 'not_empty'
        },
      ]
    case FORM_ITEM__ADDRESS:
      return [
        {
          name: '属于',
          method: 'all'
        },
        {
          name: '不属于',
          method: 'nin'
        },
        {
          name: '为空',
          method: 'empty'
        },
        {
          name: '不为空',
          method: 'not_empty'
        },
      ]
    case FORM_ITEM__MEMBER:
    case FORM_ITEM__DEPARTMENT:
      return [
        {
          name: '等于',
          method: 'eq'
        },
        {
          name: '不等于',
          method: 'ne'
        },
        {
          name: '不等于任意一个',
          method: 'nin'
        },
        {
          name: '包含任意一个',
          method: 'in'
        },
        {
          name: '同时包含',
          method: 'all'
        },
        {
          name: '为空',
          method: 'empty'
        },
        {
          name: '不为空',
          method: 'not_empty'
        },
      ]
    case FORM_ITEM__SLIDING_BLOCK:
    case FORM_ITEM__GRADE:
      return [
        {
          name: '等于',
          method: 'eq'
        },
        {
          name: '不等于',
          method: 'ne'
        },
        {
          name: '大于',
          method: 'gt'
        },
        {
          name: '大于等于',
          method: 'gte'
        },
        {
          name: '小于',
          method: 'lt'
        },
        {
          name: '小于等于',
          method: 'lte'
        },
        {
          name: '为空',
          method: 'empty'
        },
        {
          name: '不为空',
          method: 'not_empty'
        },
      ]
    case FORM_ITEM__CURRENT_VIEW_USER:
      return [
        {
          name: '不等于任意一个',
          method: 'nin'
        },
        {
          name: '等于任意一个',
          method: 'in'
        },
        {
          name: '同时包含',
          method: 'all'
        },
        {
          name: '为空',
          method: 'empty'
        },
        {
          name: '不为空',
          method: 'not_empty'
        },
      ]
    case FORM_ITEM__FORM_RUN_STATUS:
      return [
        {
          name: '等于',
          method: 'eq'
        },
        {
          name: '不等于',
          method: 'ne'
        },
      ]
    case FORM_ITEM__FLOW_DETAIL_INFO:
      return [
        {
          name: '包含',
          method: 'like'
        },
      ]
    default:
      return [
        {
          name: '为空',
          method: 'empty'
        },
        {
          name: '不为空',
          method: 'not_empty'
        }
      ]
  }
}

// 获取筛选条件结果
export function getFilterResults(filterInfo, dataValues) {
  if (!filterInfo) {
    return false
  }

  for (let i = 0; i < filterInfo.conditionList.length; i++) {
    const item = filterInfo.conditionList[i]

    if (item.fixedValue === 'fixed_value') {

      if (!item.value.length &&
        item.method !== FILTER_METHOD_TYPE__EMPTY &&
        item.method !== FILTER_METHOD_TYPE__NOT_EMPTY) {
        continue
      }
      // 如果是区间，value必须要有两个数据，并且都不能为空
      if (item.method === FILTER_METHOD_TYPE__RANGE && (item.value.length < 2 || isEmpty(item.value[0]) || isEmpty(item.value[1]))) {
        continue
      }

    } else if (item.fixedValue === 'current_user') {
      item.value = [contextVue.$store.getters.userId]
    } else if (item.fixedValue === 'now') {
      item.value = [new Date().getTime()]
    } else {
      if (item.method === FILTER_METHOD_TYPE__EQ) {
        item.method = FILTER_METHOD_TYPE__RANGE
      }
      if (item.fixedValue === 'TODAY') {
        item.value = [startTime(new Date().getTime()), endTime(new Date().getTime())]
      } else if (item.fixedValue === 'YESTERDAY') {
        const yesterday = new Date().getTime() - 86400000
        item.value = [startTime(yesterday), endTime(yesterday)]
      } else if (item.fixedValue === 'THIS_WEEK') {
        item.value = [showWeekFirstDay(), showWeekLastDay()]
      } else if (item.fixedValue === 'LAST_WEEK') {
        item.value = [getPreviousWeekFirstDay(), getPreviousWeekLastDay()]
      } else if (item.fixedValue === 'THIS_MONTH') {
        item.value = [getCurrentMonthFirst(), getCurrentMonthLast()]
      } else if (item.fixedValue === 'LAST_MONTH') {
        item.value = getPreviousMonth()
      }
    }

    let dataValue = dataValues[item.fieldId]
    if (item.type === FORM_ITEM__MEMBER) {
      dataValue = dataValues[item.fieldId].member
    } else if (item.type === FORM_ITEM__DEPARTMENT) {
      dataValue = dataValues[item.fieldId].depart
    } else if (item.type === FORM_ITEM__CURRENT_VIEW_USER) {
      const value = dataValues[item.fieldId]
      if (item.currentViewUserFilterType === 'DEPARTMENT') {
        dataValue = value.depart
      } else if (item.currentViewUserFilterType === 'ROLE') {
        dataValue = value.role
      } else if (item.currentViewUserFilterType === 'TAG') {
        dataValue = value.externalTag
      } else {
        dataValue = [...value.member, ...value.external]
      }
    } else if (item.type === FORM_ITEM__SUMMARY) {
      dataValue = dataValues[item.fieldId].summaryValue
    } else if (item.type === FORM_ITEM__RELATE_RECORD) {
      dataValue = dataValues[item.fieldId].instanceIdList
    } else if (item.type === FORM_ITEM__ADDRESS) {
      const value = dataValues[item.fieldId]
      dataValue = [value.province, value.city, value.county]
    }

    const result = getConditionResults(item, dataValue)
    if (filterInfo.relation === 'and') {
      if (!result) {
        return false
      }
    } else {
      if (result) {
        return true
      }
    }
  }

  if (filterInfo.relation === 'and') {
    return true
  } else {
    return false
  }
}

export function getConditionResults(filter, dataValue) {
  let result = true
  switch (filter.method) {
    case FILTER_METHOD_TYPE__EQ: {
      // 等于
      let arrayValue = []
      if (isArray(dataValue)) {
        arrayValue.push(...dataValue)
      } else {
        arrayValue.push(dataValue)
      }
      result = arrayEquals(filter.value, arrayValue)
      break;
    }
    case FILTER_METHOD_TYPE__NE: {
      // 不等于
      if (filter.type === FORM_ITEM__DATE && filter.fixedValue !== 'now') {
        const matchValue1 = filter.value[0]
        const matchValue2 = filter.value[1]
        result = dataValue < matchValue1 || dataValue > matchValue2
      } else {
        let arrayValue = []
        if (isArray(dataValue)) {
          arrayValue.push(...dataValue)
        } else {
          arrayValue.push(dataValue)
        }
        result = !arrayEquals(filter.value, arrayValue)
      }
      break;
    }
    case FILTER_METHOD_TYPE__LIKE: {
      // 包含
      const fieldValueStr = String(dataValue)
      const matchValue = String(filter.value[0])
      result = fieldValueStr.includes(matchValue)
      break;
    }
    case FILTER_METHOD_TYPE__UNLIKE: {
      // 不包含
      const fieldValueStr = String(dataValue)
      const matchValue = String(filter.value[0])
      result = !fieldValueStr.includes(matchValue)
      break;
    }
    case FILTER_METHOD_TYPE__IN: {
      // 等于任意一个   包含任意一个
      if (isArray(dataValue)) {
        // 俩个数组交集
        result = !!getArrRepeat(filter.value, dataValue).length
      }  else {
        result = !!getArrRepeat(filter.value, [dataValue]).length
      }
      break;
    }
    case FILTER_METHOD_TYPE__NIN: {
      // 不等于任意一个  不属于
      if (isArray(dataValue)) {
        // 俩个数组交集
        result = !getArrRepeat(filter.value, dataValue).length
      } else {
        result = !getArrRepeat(filter.value, [dataValue]).length
      }
      break;
    }
    case FILTER_METHOD_TYPE__ALL: {
      // 同时包含   属于
      if (isArray(dataValue)) {
        // 俩个数组交集
        const repeatArr = getArrRepeat(filter.value, dataValue)
        // 交集是否和dataValue相同
        result = arrayEquals(filter.value, repeatArr)
      } else if (isString(dataValue)) {
        // 俩个数组交集
        const repeatArr = getArrRepeat(filter.value, [dataValue])
        // 交集是否和dataValue相同
        result = arrayEquals(filter.value, repeatArr)
      } else {
        result = filter.value.includes(dataValue)
      }
      break;
    }
    case FILTER_METHOD_TYPE__GT: {
      // 大于
      let matchValue = filter.value[0]
      if (filter.type === FORM_ITEM__DATE && filter.fixedValue !== 'now') {
        matchValue = filter.value[1]
      }
      if (dataValue !== 0 && !dataValue) {
        result = false
      } else {
        result = dataValue > matchValue
      }
      break;
    }
    case FILTER_METHOD_TYPE__GTE: {
      // 大于等于
      const matchValue = filter.value[0]
      if (dataValue !== 0 && !dataValue) {
        result = false
      } else {
        result = dataValue >= matchValue
      }
      break;
    }
    case FILTER_METHOD_TYPE__LTE: {
      // 小于等于
      let matchValue = filter.value[0]
      if (filter.type === FORM_ITEM__DATE && filter.fixedValue !== 'now') {
        matchValue = filter.value[1]
      }
      if (dataValue !== 0 && !dataValue) {
        result = false
      } else {
        result = dataValue <= matchValue
      }
      break;
    }
    case FILTER_METHOD_TYPE__LT: {
      // 小于
      const matchValue = filter.value[0]
      if (dataValue !== 0 && !dataValue) {
        result = false
      } else {
        result = dataValue < matchValue
      }
      break;
    }
    case FILTER_METHOD_TYPE__RANGE: {
      // 选择范围
      const matchValue1 = filter.value[0]
      const matchValue2 = filter.value[1]
      result = dataValue >= matchValue1 && dataValue <= matchValue2
      break;
    }
    case FILTER_METHOD_TYPE__EMPTY: {
      if (isArray(dataValue) || isString(dataValue)) {
        result = !dataValue || !dataValue.length
      } else {
        result = !dataValue
      }
      break;
    }
    case FILTER_METHOD_TYPE__NOT_EMPTY: {
      if (isArray(dataValue) || isString(dataValue)) {
        result = !!(dataValue && dataValue.length)
      } else {
        result = !!dataValue
      }
      break;
    }
    default:
      break;
  }
  return result
}

export function areaList(list, code, tier) {
  if (AreaData[code] && tier) {
    Object.keys(AreaData[code]).forEach(key => {
      const opt = {
        value: key,
        label: AreaData[code][key],
        children: null
      }
      opt.children = areaList([], key, tier - 1)

      if (opt.children.length === 0) {
        delete opt.children
      }

      list.push(opt)
    })
  }
  return list
}

export function provinceOptions() {
  return areaList([], 86, 1)
}

export function cityOptions() {
  return areaList([], 86, 2)
}

export function countyOptions() {
  return areaList([], 86, 3)
}

// base64编码
export function base64Encode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
    function toSolidBytes(match, p1) {
      return String.fromCharCode('0x' + p1);
    }));
}

// base64转码
export function base64Decode(str) {
  return decodeURIComponent(atob(str).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
}

export function typeString(object) {
  return Object.prototype.toString.call(object).slice(8, -1).toLowerCase();
}

export function isNull(object) {
  return typeString(object) === 'null';
}

export function isUndefined(object) {
  return typeof(object) === "undefined"
  // return typeString(object) === 'undefined';
}

export function isEmpty(object) {
  return isNull(object) || isUndefined(object)
}

export function isNumber(object) {
  return typeString(object) === 'number';
}

export function isString(object) {
  return typeString(object) === 'string';
}

export function isBoolean(object) {
  return typeString(object) === 'boolean';
}

export function isFunction(object) {
  return typeString(object) === 'function';
}

export function isArray(object) {
  return typeString(object) === 'array';
}

function isDate(object) {
  return typeString(object) === 'date';
}

export function isRegExp(object) {
  return typeString(object) === 'regexp';
}

export function isObject(object) {
  return typeString(object) === 'object';
}

export function isEmail(val) {
  const pattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  const domains= ["qq.com","163.com","vip.163.com","263.net","yeah.net","sohu.com","sina.cn","sina.com","eyou.com","gmail.com","hotmail.com","42du.cn"];
  if(pattern.test(val)) {
    const domain = val.substring(val.indexOf("@")+1);
    for(let i = 0; i< domains.length; i++) {
      if(domain === domains[i]) {
        return true;
      }
    }
  }
  return false;
}

export function trim(str, is_global) {
  let result;
  result = str.replace(/(^\s+)|(\s+$)/g, "");
  if (is_global && is_global.toLowerCase() === "g") {
    result = result.replace(/\s/g, "");
  }
  return result;
}

// 判断是否是手机号码格式
export function isPhone(str) {
  if (!str) {
    return false
  }
  const reg = /^1([34578])\d{9}$/;
  return reg.test(trim(str, 'g'));
}

// 手机号码格式转化为 344 格式 （188 3886 9199）
export function phoneSeparated (phoneNumber) {
  let tel = trim(phoneNumber, 'g');
  if (isPhone(tel)) {
    tel = tel.substring(0, 3) + ' ' + tel.substring(3, 7) + ' ' + tel.substring(7, 11);
  }
  return tel;
}

export function handleMessage(formSet, {messageType, context, content}) {
  console.log('handleMessage--', {messageType, context, content})
  if (formSet && messageType === MESSAGE_TYPE_UPDATE_FORM) {
    const {version, msgType, subTable, subHandleType, rowIdx, resultData = []} = content
    contextVue.$store.commit('UPDATE_USER_MAP', content.memberDetailMap)
    contextVue.$store.commit('UPDATE_EXTERNAL_MAP', content.externalDetailMap)
    if (msgType === MESSAGE_TYPE_DATA) {
      delete formSet.submitMap[version]
      if (version >= formSet.lastReciveTime) {
        formSet.lastReciveTime = version
      } else {
        // 消息乱序，上报服务器
        contextVue.$store.dispatch('actionFormMsgErrorUpload', {
          appId: formSet.appId,
          formId: formSet.formId,
          traceId: formSet.traceId,
          errorType: 'OUT_OF_ORDER',
          deviceType: 'MINI_APP',
          scene: formSet.instanceId ? 'EDIT' : 'CREATE',
          costTime: ''
        }).catch(console.error)
      }
      resultData.forEach(item => {
        const formItem = formSet.fields[item.fieldId]
        if (formItem && formItem.setValue) {
          if (formItem.verTT && formItem.verTT <= version) {
            formItem.verTT = version
            if (formItem.type === FORM_ITEM__TABLE) {
              if (subHandleType === 'COVER') {
                formItem.setValue(item.fieldValue)
              } else {
                formItem.updateValue(item.fieldValue)
              }
            } else {
              formItem.setValue(item.fieldValue)
            }
            formItem.modified = true
          } else if (!formItem.verTT) {
            formItem.verTT = version
            if (formItem.type === FORM_ITEM__TABLE) {
              if (subHandleType === 'COVER') {
                formItem.setValue(item.fieldValue)
              } else {
                formItem.updateValue(item.fieldValue)
              }
            } else {
              formItem.setValue(item.fieldValue)
            }
            formItem.modified = true
          }
        }
      })
    } else if (msgType === MESSAGE_TYPE_APPEND) {
      if (subTable) {
        resultData.forEach(item => {
          const formItem = formSet.fields[item.fieldId]
          const formTableItem = formItem.parent
          console.log('formTableItem', formTableItem)
          if (formTableItem && formTableItem.appendValue) {
            if (formTableItem.verTT && formTableItem.verTT <= version) {
              formTableItem.verTT = version
              formTableItem.appendValue({
                val: item.fieldValue,
                rowIdx,
                fieldId: item.fieldId,
                fieldType: formItem.type
              })
              formTableItem.modified = true
            } else if (!formTableItem.verTT) {
              formTableItem.verTT = version
              formTableItem.appendValue({
                val: item.fieldValue,
                rowIdx,
                fieldId: item.fieldId,
                fieldType: formItem.type
              })
              formTableItem.modified = true
            }
          }
        })
      } else {
        resultData.forEach(item => {
          const formItem = formSet.fields[item.fieldId]
          if (formItem && formItem.appendValue) {
            if (formItem.verTT && formItem.verTT <= version) {
              formItem.verTT = version
              formItem.appendValue(item.fieldValue)
              formItem.modified = true
            } else if (!formItem.verTT) {
              formItem.verTT = version
              formItem.appendValue(item.fieldValue)
              formItem.modified = true
            }
          }
        })
      }
    } else if (msgType === MESSAGE_TYPE_SIGNATURE) {
      if (subTable) {
        resultData.forEach(item => {
          const formItem = formSet.fields[item.fieldId]
          const formTableItem = formItem.parent
          console.log('formTableItem', formTableItem)
          if (formTableItem && formTableItem.replaceValue) {
            if (formTableItem.verTT && formTableItem.verTT <= version) {
              formTableItem.verTT = version
              formTableItem.replaceValue({
                val: item.fieldValue,
                rowIdx,
                fieldId: item.fieldId,
                fieldType: formItem.type
              })
              formTableItem.modified = true
            } else if (!formTableItem.verTT) {
              formTableItem.verTT = version
              formTableItem.replaceValue({
                val: item.fieldValue,
                rowIdx,
                fieldId: item.fieldId,
                fieldType: formItem.type
              })
              formTableItem.modified = true
            }
          }
        })
      } else {
        resultData.forEach(item => {
          const formItem = formSet.fields[item.fieldId]
          if (formItem && formItem.setValue) {
            if (formItem.verTT && formItem.verTT <= version) {
              formItem.verTT = version
              formItem.setValue(item.fieldValue)
              formItem.modified = true
            } else if (!formItem.verTT) {
              formItem.verTT = version
              formItem.setValue(item.fieldValue)
              formItem.modified = true
            }
          }
        })
      }
    } else if (msgType === MESSAGE_TYPE_UPLOAD_IMAGE) {
      if (subTable) {
        resultData.forEach(item => {
          const formItem = formSet.fields[item.fieldId]
          const formTableItem = formItem.parent
          console.log('formTableItem', formTableItem)
          if (formTableItem && formTableItem.appendValue) {
            if (formTableItem.verTT && formTableItem.verTT <= version) {
              formTableItem.verTT = version
              formTableItem.appendValue({
                val: item.fieldValue,
                rowIdx,
                fieldId: item.fieldId,
                fieldType: formItem.type
              })
              formTableItem.modified = true
            } else if (!formTableItem.verTT) {
              formTableItem.verTT = version
              formTableItem.appendValue({
                val: item.fieldValue,
                rowIdx,
                fieldId: item.fieldId,
                fieldType: formItem.type
              })
              formTableItem.modified = true
            }
          }
        })
      } else {
        resultData.forEach(item => {
          const formItem = formSet.fields[item.fieldId]
          if (formItem && formItem.appendValue) {
            if (formItem.verTT && formItem.verTT <= version) {
              formItem.verTT = version
              formItem.appendValue(item.fieldValue)
              formItem.modified = true
            } else if (!formItem.verTT) {
              formItem.verTT = version
              formItem.appendValue(item.fieldValue)
              formItem.modified = true
            }
          }
        })
      }

      const changeFlowEvent = new CustomEvent('UPLOAD_IMAGE_SUCCESS', {detail: {content}})
      document.dispatchEvent(changeFlowEvent)
    }

    // 计算显隐
    formSet.computeDisplayResults()
  }
}

//设置cookie
export function setCookie(key, value, expiredays){
  const exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = key + "=" + escape(value) + ((expiredays==null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/;";
}

//取回cookie
export function getCookie(key) {
  let c_start = ''
  let c_end = ''
  if (document.cookie.length > 0) {
    c_start = document.cookie.indexOf(key + "=");
    if (c_start !== -1) {
      c_start = c_start + key.length + 1;
      c_end = document.cookie.indexOf(";", c_start);
      if (c_end === -1) {
        c_end = document.cookie.length;
      }
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return "";
}


// 加密
export function encrypt(word, keyStr) {
  keyStr = keyStr ? keyStr : "";
  let key = CryptoJS.enc.Utf8.parse(keyStr);
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}

// 解密
export function decrypt(word, keyStr) {
  keyStr = keyStr ? keyStr : "";
  let key = CryptoJS.enc.Utf8.parse(keyStr);

  // let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  // let encryptedBase64Str = CryptoJS.enc.Base64.stringify(encryptedHexStr);

  let decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });

  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  // return CryptoJS.enc.Utf8.stringify(decrypt)
}

export function md5encode(word) {
  return CryptoJS.MD5(word).toString(CryptoJS.enc.HEX);
}


// 加密数据
export function encodeData({type = ENCODE_TYPE_ZEUS, data}) {
  try {
    if (type === ENCODE_TYPE_ZEUS) {
      const timestamp = (new Date()).getTime()
      // 拿时间戳最后一位
      const n = timestamp % 10

      // 获取秘钥
      const key = timestamp.toString().slice(-n)
      const md5Key = md5encode(key)

      // 加密数据
      const encodeData = encrypt(JSON.stringify(data), md5Key)

      // 组装数据
      return `${timestamp},${type},${encodeData}`
    }
  } catch (e) {
    console.log(e)
  }
}

// 解密数据
export function decodeData(encodeStr) {

  try {
    const result = encodeStr.split(",")
    const timestamp = result[0]
    const type = result[1]
    const decodeStr = result[2]

    if (type === ENCODE_TYPE_ZEUS) {
      const n = timestamp % 10
      const key = timestamp.slice(-n)

      const decodeResultStr = decrypt(decodeStr, md5encode(key))

      return JSON.parse(decodeResultStr)
    }
  } catch (e) {
    console.log(e)
  }

}

// html中获取纯文本
export function getSimpleText(html) {
  const re1 = new RegExp("<.+?>", "g");//匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
  const msg = html.replace(re1, '');//执行替换成空字符
  return msg;
}

export function fileType2FileImage(type) {
  type = type ? type.split('/').slice(-1)[0] : ''
  let image = ''
  switch (type) {
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'bmp':
    case 'gif':
    case 'webp':
    case 'psd':
    case 'svg':
    case 'tiff':
    case 'image/png':
    case 'image/jpg':
    case 'image/jpeg':
      image = '#icon-tupian'
      break
    case 'text/plain':
    case 'plain':
    case 'rtf':
    case 'txt':
    case 'properties':
    case 'asp':
    case 'jsp':
    case 'md':
    case 'gitignore':
    case 'log':
    case 'java':
    case 'py':
    case 'c':
    case 'cpp':
    case 'sql':
    case 'sh':
    case 'bat':
    case 'm':
    case 'bas':
    case 'prg':
    case 'cmd':
      image = '#icon-txt'
      break
    case 'pdf':
    case 'application/pdf':
      image = '#icon-pdf'
      break
    case 'application/zip':
    case 'zip':
    case 'x-zip-compressed':
      image = '#icon-zip2'
      break
    case 'rar':
    case 'RAR':
      image = '#icon-RAR1'
      break
    case 'csv':
      image = '#icon-csv'
      break
    case 'xml':
      image = '#icon-xml'
      break
    case 'json':
      image = '#icon-json'
      break
    case 'html':
    case 'htm':
      image = '#icon-html'
      break
    case 'mp3':
      image = '#icon-mp1'
      break
    case 'wav':
      image = '#icon-WAV'
      break
    case 'mp4':
      image = '#icon-mp'
      break
    case 'flv':
      image = '#icon-flv'
      break
    case 'doc':
    case 'docm':
    case 'docx':
    case 'dot':
    case 'dotm':
    case 'dotx':
    case 'wps':
    case 'xps':
    case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
    case 'msword':
      image = '#icon-word'
      break
    case 'csv':
    case 'dbf':
    case 'dif':
    case 'xls':
    case 'xlsb':
    case 'xlam':
    case 'xlsm':
    case 'xlsx':
      image = '#icon-excel'
      break
    case 'pot':
    case 'potx':
    case 'ppa':
    case 'pps':
    case 'pptm':
    case 'ppt':
    case 'pptx':
    case 'application/vnd.ms-powerpoint':
    case 'vnd.ms-powerpoint':
    case 'vnd.openxmlformats-officedocument.presentationml.presentation':
      image = '#icon-ppt'
      break
    default:
      image = '#icon-weizhigeshi'
      break
  }
  return image
}

export function iconList() {
  return [
    "iconfont icon-activity",
    "iconfont icon-activity_fill",
    "iconfont icon-addition_fill",
    "iconfont icon-addition",
    "iconfont icon-addpeople_fill",
    "iconfont icon-addpeople",
    "iconfont icon-addressbook_fill",
    "iconfont icon-addressbook",
    "iconfont icon-barrage_fill",
    "iconfont icon-barrage",
    "iconfont icon-browse_fill",
    "iconfont icon-browse",
    "iconfont icon-businesscard_fill",
    "iconfont icon-businesscard",
    "iconfont icon-camera_fill",
    "iconfont icon-camera",
    "iconfont icon-clock_fill",
    "iconfont icon-clock",
    "iconfont icon-collection_fill",
    "iconfont icon-collection",
    "iconfont icon-computer_fill",
    "iconfont icon-computer",
    "iconfont icon-coordinates_fill",
    "iconfont icon-coordinates",
    "iconfont icon-coupons_fill",
    "iconfont icon-coupons",
    "iconfont icon-createtask_fill",
    "iconfont icon-createtask",
    "iconfont icon-customerservice_fill",
    "iconfont icon-customerservice",
    "iconfont icon-document",
    "iconfont icon-document_fill",
    "iconfont icon-dynamic_fill",
    "iconfont icon-dynamic",
    "iconfont icon-emoji_fill",
    "iconfont icon-emoji",
    "iconfont icon-empty",
    "iconfont icon-empty_fill",
    "iconfont icon-feedback_fill",
    "iconfont icon-feedback",
    "iconfont icon-flag_fill",
    "iconfont icon-flag",
    "iconfont icon-flashlight",
    "iconfont icon-flashlight_fill",
    "iconfont icon-flip",
    "iconfont icon-flip_fill",
    "iconfont icon-group",
    "iconfont icon-group_fill",
    "iconfont icon-headlines_fill",
    "iconfont icon-headlines",
    "iconfont icon-homepage_fill",
    "iconfont icon-homepage",
    "iconfont icon-integral_fill",
    "iconfont icon-integral",
    "iconfont icon-interactive_fill",
    "iconfont icon-interactive",
    "iconfont icon-label",
    "iconfont icon-label_fill",
    "iconfont icon-like_fill",
    "iconfont icon-like",
    "iconfont icon-live_fill",
    "iconfont icon-live",
    "iconfont icon-lock_fill",
    "iconfont icon-lock",
    "iconfont icon-mail",
    "iconfont icon-mail_fill",
    "iconfont icon-manage_fill",
    "iconfont icon-manage",
    "iconfont icon-message",
    "iconfont icon-message_fill",
    "iconfont icon-mine",
    "iconfont icon-mine_fill",
    "iconfont icon-mobilephone_fill",
    "iconfont icon-mobilephone",
    "iconfont icon-people_fill",
    "iconfont icon-people",
    "iconfont icon-picture_fill",
    "iconfont icon-picture",
    "iconfont icon-playon_fill",
    "iconfont icon-playon",
    "iconfont icon-praise_fill",
    "iconfont icon-praise",
    "iconfont icon-qrcode_fill",
    "iconfont icon-qrcode",
    "iconfont icon-redpacket_fill",
    "iconfont icon-redpacket",
    "iconfont icon-remind_fill",
    "iconfont icon-remind",
    "iconfont icon-select_fill",
    "iconfont icon-select",
    "iconfont icon-service_fill",
    "iconfont icon-service",
    "iconfont icon-setup_fill",
    "iconfont icon-setup",
    "iconfont icon-share_fill",
    "iconfont icon-share",
    "iconfont icon-shielding_fill",
    "iconfont icon-shielding",
    "iconfont icon-success_fill",
    "iconfont icon-success",
    "iconfont icon-systemprompt_fill",
    "iconfont icon-systemprompt",
    "iconfont icon-task",
    "iconfont icon-task_fill",
    "iconfont icon-tasklist_fill",
    "iconfont icon-tasklist",
    "iconfont icon-time_fill",
    "iconfont icon-time",
    "iconfont icon-video",
    "iconfont icon-video_fill",
    "iconfont icon-warning_fill",
    "iconfont icon-warning",
    "iconfont icon-workbench_fill",
    "iconfont icon-workbench",
    "iconfont icon-publishgoods_fill",
    "iconfont icon-shop_fill",
    "iconfont icon-financial_fill",
    "iconfont icon-marketing_fill",
    "iconfont icon-questions",
    "iconfont icon-tools"
  ]
}

//str：要进行隐藏的变量  frontLen: 前面需要保留几位    endLen: 后面需要保留几位
export function hiddenStr(str, frontLen, endLen) {
  let len = str.length - frontLen - endLen;
  let xing = '';
  for (let i = 0; i < len; i++) {
    xing += '*';
  }
  return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
}

// 是否是手机号
// export function isPhone(s) {
//   if (!s) {
//     return false
//   }
//   if (phones['+86'].pattern.test('+86' + s)) {
//     return true
//   } else {
//     return false
//   }
// }
// 是否是身份证号
export function isIDCard(IDCard) {
  if (!IDCard) {
    return false
  }
  let reg =/(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/;
  if(reg.test(IDCard)){
    return true
  } else {
    return false
  }
}

// 替换字符串中电话号和网址成超链接
export function selectPhoneNumberAndUrl(str) {
  if (!str) {
    return str
  }

  // const regx = /(1[3|4|5|7|8][\d]{9}|0[\d]{2,3}-[\d]{7,8}|400[-]?[\d]{3}[-]?[\d]{4})/g;
  // let phoneNums1 = str.match(regx);
  // console.log('phoneNums11--', phoneNums1)
  let phoneNums = str.match(/-?([1-9]\d*(\.\d*)*|0\.[1-9]\d*)/g);
  if (phoneNums && phoneNums.length) {
    phoneNums = Array.from(new Set(phoneNums))
    for (let i = 0; i < phoneNums.length; i++) {
      let temp = phoneNums[i]
      if (isPhone(temp)) {
        str = str.replace(temp, '<a href="tel:' + temp + '"  class="copy phone-num" style=" text-decoration: underline;color: #2878FF;" target="_blank">' + temp + '</a>');
      }
    }
  }

  var key="&amp;";
  str = str.replace(new RegExp(key,'g'),"&");

  var re = /(http|ftp|https):\/\/[\w-]+(.[\w-]+)+([\w-.,@?^=%&:/~+#]*[\w-\@?^=%&/~+#])?/g

  str = str.replace(re, function(website){
    return "<a id='urlA' href='" + website +"' target='_blank'>" + website + "</a>";
  });
  // 替换换行
  str.replace(/(\r\n|\n|\r)/gm, '<br />')
  return str;
}

export function isURL(strUrl) {
  const regular = /^\b(((https?|ftp):\/\/)?[-a-z0-9]+(\.[-a-z0-9]+)*\.(?:com|edu|gov|int|mil|net|org|biz|info|name|museum|asia|coop|aero|[a-z][a-z]|((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]\d)|\d))\b(\/[-a-z0-9_:\@&?=+,.!\/~%\$]*)?)$/i;
  if (regular.test(strUrl)) {
    return true;
  } else {
    return false;
  }
}
export function compare(prop) {
  return function (obj1, obj2) {
    const val1 = obj1[prop];
    const val2 = obj2[prop];
    if (val1 > val2) {
      return 1;
    } else if (val1 < val2) {
      return -1;
    } else {
      return 0;
    }
  }
}

export function formatNum(strNum) {
  if (strNum.length <= 3) {
    return strNum;
  }
  if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(strNum)) {
    return strNum;
  }
  var a = RegExp.$1,
    b = RegExp.$2,
    c = RegExp.$3;
  var re = new RegExp();
  re.compile("(\\d)(\\d{3})(,|$)");
  while (re.test(b)) {
    b = b.replace(re, "$1,$2$3");
  }
  return a + "" + b + "" + c;
}

export function hexToRgba(hex, opacity) {
  if (!hex) {
    return ''
  }
  if (hex.includes('#')) {
    return colorRgba(hex, opacity)
  }
  const rgb = hex.split('(')[1].split(')')[0].split(',');
  return 'rgba(' + rgb[0].trim() + ',' + rgb[1].trim() + ',' + rgb[2].trim() + ',' + opacity + ')';
}

export function colorRgba(sHex, alpha) {
  // 十六进制颜色值的正则表达式
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  /* 16进制颜色转为RGB格式 */
  let sColor = sHex.toLowerCase()
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      let sColorNew = '#'
      for (let i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
      }
      sColor = sColorNew
    }
    // 处理六位的颜色值
    let sColorChange = []
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))
    }
    // return sColorChange.join(',')
    return 'rgba(' + sColorChange.join(',') + ',' + alpha + ')'
  } else {
    return sColor
  }
}
export function hexToRgb(hex) {
  let rgb = [];
  for (let i = 1; i < 7; i += 2) {
    rgb.push(parseInt("0x" + hex.slice(i, i + 2)));
  }
  return rgb;
}

export function getBlob(url, cb) {
  let xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.onload = function () {
    if (xhr.status === 200) {
      cb(xhr.response);
    }
  }
  xhr.send();
}
// 判断filter对象中conditionList里面的条件的为空不为空
export function filterEmpty(filter) {
  if (!filter.conditionList || !filter.conditionList.length) {
    return false
  }
  let isEmpty = true
  filter.conditionList.forEach(item => {

    if (item.method === 'empty' || item.method === 'not_empty') {
      isEmpty = false
    } else if (item.fixedValue !== 'fixed_value') {
      isEmpty = false
    } else if (item.method !== 'empty' && item.method !== 'not_empty' && item.value.length) {
      item.value.forEach(value => {
        if (isNumber(value)) {
          isEmpty = false
        } else if (isString(value) && value.length) {
          isEmpty = false
        }
      })
    }
  })
  return isEmpty
}

/**
 * 计算渐变过渡色 rgb颜色
 * @param {*} startColor
 * @param {*} endColor
 * @param {*} step
 */
export function gradient(startColor, endColor, step) {
  // 将 hex 转换为rgb
  let sColor = hexToRgb(startColor),
    eColor = hexToRgb(endColor);
  // 计算R\G\B每一步的差值
  let rStep = (eColor[0] - sColor[0]) / step,
    gStep = (eColor[1] - sColor[1]) / step,
    bStep = (eColor[2] - sColor[2]) / step;

  let gradientColorArr = [];
  for (let i = 0; i < step; i++) {
    // 计算每一步的hex值
    gradientColorArr.push(rgbToHex(parseInt(rStep * i + sColor[0]), parseInt(gStep * i + sColor[1]), parseInt(bStep * i + sColor[2])));
  }
  return gradientColorArr;
}

export function findArrayMax(arr) {
  // 首先判断参数 arr 是不是一个数组
  if (Object.prototype.toString.call(arr) !== '[object Array]') {
    // 如果不是数组则返回 NaN
    return NaN
  }

  // 将变量 max 的初始值设置为 - Infinity，并将数组的长度用变量保存起来，避免循环时重复求值
  let max = -Infinity, len = arr.length;

  // 使用 for 循环遍历数组中的元素
  for (let i = 0; i < len; i++) {
    // 如果该元素为 NaN 则该函数直接返回 NaN
    if (isNaN(arr[i])) {
      return NaN
    } else if (arr[i] > max) {
      max = arr[i];
    }
  }

  // 遍历完成后，将返回最大值 max
  return Number(max)
}